/**
 * @author       denys.yefremov@startupsoft.co (Denys Yefremov)
 * @copyright    Copyright (c) 2022, Zumper
 */

import * as Api from '@zcode/nr/es/shared/api'
import type { Address, Property, School } from '@zcode/state-type'
import type { Dispatch } from 'redux'
import { receiveLocationSchools } from '../actions/index'

const schoolsLevels = ['elementary', 'middle', 'high', 'private'] as const

export const loadLocationSchools =
  (address: Pick<Address | Property, 'lat' | 'lng'>) => async (dispatch: Dispatch) => {
    const { lat, lng } = address
    let hasSchools = false

    if (lat && lng) {
      const params = {
        lat,
        lng,
      }

      const schools = await Promise.allSettled(
        schoolsLevels.map(async (level) => {
          if (level === 'private') {
            return await Api.poiPrivateSchools.get(params)
          }
          return await Api.poiSchools.get({ schoolLevel: level, ...params })
        })
      )

      const schoolsObject = schoolsLevels.reduce<{
        [level in (typeof schoolsLevels)[number]]?: readonly School[]
      }>((acc, level, index) => {
        const result = schools[index]

        if (result.status === 'fulfilled' && result.value?.schools?.length > 0) {
          acc[level] = result.value.schools
          return acc
        }

        return acc
      }, {})

      dispatch(receiveLocationSchools(schoolsObject))
      hasSchools = true
    }
    if (!hasSchools) {
      dispatch(receiveLocationSchools({}))
    }
  }
